import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { ReportSchema, type Report, type ReportsQuery } from '@datazo/contracts';
import { apiFetch } from '@/shared/api/client';

export const reportsKeys = {
  report: (q: ReportsQuery) => ['reports', q] as const,
};

function buildQs(q: ReportsQuery): string {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v !== undefined && v !== '') usp.set(k, String(v));
  }
  return usp.toString();
}

export function useReport(q: ReportsQuery): UseQueryResult<Report, Error> {
  return useQuery({
    queryKey: reportsKeys.report(q),
    queryFn: () =>
      apiFetch<Report>(`/api/reports?${buildQs(q)}`, { parseAs: ReportSchema }),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
